import { AxiosInstance } from 'axios';
import { FeatureRepository } from '@/model/repository/manager/feature/FeatureRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): FeatureRepository => ({
    isExistFlag(featureName: string) {
      return Repository.get(`${resource}/feature-flags/${featureName}`);
    },
  });
